module.exports = __webpack_public_path__ + "static/img/SketchPng2f17c37476775e9363f4168b00fa4570ad19be70f972c7d1c67132ac6ae29343.08614416.png";